export default "__VITE_ASSET__BtUhRR_K__"